import { Z_INDEX as GLOBAL_Z_INDEX } from '../styles/config';

export const Z_INDEX = {
  BACKGROUND: GLOBAL_Z_INDEX.navigation - 3,
  MEDIUM: GLOBAL_Z_INDEX.navigation - 2,
  FLYOUT_PANEL: GLOBAL_Z_INDEX.navigation - 2,
  SHIFTS_INFO: GLOBAL_Z_INDEX.navigation - 1,
  USAGE_DISABLED: GLOBAL_Z_INDEX.navigation - 1,
  NAVIGATION: GLOBAL_Z_INDEX.navigation,
  DROPDOWN: GLOBAL_Z_INDEX.navigation + 3,
  OVERLAY: GLOBAL_Z_INDEX.navigation + 4,
  INACTIVITY: GLOBAL_Z_INDEX.navigation + 5,
  BANNER: GLOBAL_Z_INDEX.navigation + 6,
};
